var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3v3H3V3h3zm1.5-1.5h-6v6h6v-6zm6 1.5v3h-3V3h3zM15 1.5H9v6h6v-6zM21 3v3h-3V3h3zm1.5-1.5h-6v6h6v-6zM6 10.5v3H3v-3h3zM7.5 9h-6v6h6V9zm6 1.5v3h-3v-3h3zM15 9H9v6h6V9zm6 1.5v3h-3v-3h3zM22.5 9h-6v6h6V9zM6 18v3H3v-3h3zm1.5-1.5h-6v6h6v-6zm6 1.5v3h-3v-3h3zm1.5-1.5H9v6h6v-6zm6 1.5v3h-3v-3h3zm1.5-1.5h-6v6h6v-6z",
    fill: "#45464F"
  })));
}
export default SvgApps;